import type React from "react";
import {
  Form as RACForm,
  type FormProps as RACFormProps,
} from "react-aria-components";

export type FormProps = RACFormProps & { ref?: React.Ref<HTMLFormElement> };

export function Form({ className, ref, ...props }: FormProps) {
  return <RACForm {...props} ref={ref} className={className} />;
}
